import React from 'react';
import PropTypes from 'prop-types';
import { DismissableMessage } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './messagebox.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MessageBox = props => {
  var messages = {
    info: {
      type: 'info',
      text: 'Consider it done.'
    },
    error: {
      type: 'error',
      text: "You won't get alerts for this anymore."
    }
  };
  return ___EmotionJSX(DismissableMessage, {
    appearance: "success",
    css: styles.message,
    onClose: props.onClose
  }, messages[props.type].text, props.type === messages.error.type && ___EmotionJSX("span", {
    css: styles.messageBoxText
  }, ___EmotionJSX("button", {
    type: "button",
    onClick: props.onUndo,
    css: styles.undoButton,
    "aria-label": "Undo"
  }, "Undo")));
};
MessageBox.propTypes = {
  type: PropTypes.oneOf(['info', 'error']).isRequired,
  onClose: PropTypes.func.isRequired,
  onUndo: PropTypes.func
};
MessageBox.defaultProps = {
  onUndo: undefined
};
export default MessageBox;